import { SchemaConvertor } from './schema.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { TransformConvertorBase } from './transform.convertor';
import { CastTransformation } from 'app/model/dataflow/casttransformation';
import { CastPlainObject } from 'worker/app-workers/shared/plainObjects/cast.plainObject';
import { IResourceContext } from 'shell-models-lib';

export class CastConvertor extends TransformConvertorBase {
    private get castTransform(): CastTransformation {
        return this.transformation as CastTransformation;
    }

    private get castObject(): CastPlainObject {
        return this.transformObject as CastPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        this.castTransform.castColumns = SchemaConvertor.convertColumnsFromPlainObject(
            this.castObject.columns,
            this.castTransform
        );

        if (this.castObject.configs.has('errors')) {
            const errors = this.castObject.configs.get('errors');
            this.castTransform.errors = errors === 'true';
            this._handledConfigs.push('errors');
        }

        super.postConvert();
        return this.castTransform;
    }
}
